<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择合同"
      width="1200px"
      top="5vh">
    <view-table
        ref="tableSelect"
        :filter="filter"
        :columns="columnsProperty"
        module="basic"
        url="clientContracts"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button type="primary" @click="selectRows">添加</el-button>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="合同编号" prop="clientContractNo">
            <el-input v-model.trim="filter.clientContractNo" placeholder="请输入合同编号"/>
          </el-form-item>
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称"/>
          </el-form-item>
          <el-form-item label="客户编号" prop="customerNo">
            <el-input v-model.trim="filter.customerNo" placeholder="请输入客户编号"/>
          </el-form-item>
          <el-form-item label="合同类型" prop="clientContractType">
            <el-select v-model="filter.clientContractType">
              <el-option label="渠道商协议" :value="10"/>
              <el-option label="框架合同" :value="20"/>
              <el-option label="产品销售合同" :value="30"/>
              <el-option label="产品借用转销售合同" :value="40"/>
              <el-option label="试用协议" :value="50"/>
              <el-option label="备品协议" :value="60"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否可用" prop="available">
            <el-select v-model="filter.available">
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    components: {ViewTable},
    data() {
      return {
        dialogVisible: false,
        filter: {
          clientContractNo: "",
          customerName: "",
          customerNo: "",
          clientContractType: "",
          available:1,
        },
        columnsProperty: [
          {
            key: "clientContractTypeDesc",
            width: 480,
            align: "center",
          },
          {
            key: "statusDesc",
            width: 120,
            align: "center",
          },
          {
            key: "clientContractNo",
            width: 300,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      // this.$refs.clientContractEditPage.open(params.row, true);
                      this.goto(params.row);
                    },
                  },
                },
                params.row.clientContractNo,
              );
            },
          },
          {
            key: "customerClientContractNo",
            minWidth: 360,
            align: "center",
          },
          {
            key: "clientContractName",
            minWidth: 360,
            align: "center",
          },
          {
            key: "customerName",
            minWidth: 360,
            align: "center",
          },
          {
            key: "customerNo",
            minWidth: 150,
            align: "center",
          },
          {
            key: "urgent",
            minWidth: 100,
            align: "center",
          },
          {
            key: "clientContractDeliveryDate",
            width: 140,
          },
          {
            key: "clientContractAmount",
            width: 100,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            minWidth: 200,
          },
          {
            key: "businessOperatorName",
            width: 100,
            align: "center",
          },
          {
            key: "clientContractAbstract",
            width: 120,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      selectRows() {
        if (this.selection.length > 1) {
          return this.$message.error("只能选择一条数据！");
        }

        this.dialogVisible = false;
        this.$emit("select", this.selection[0]);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
